import angular from 'angular';
import riskAnalysisComponent from './risk-analysis.component';

export default angular.module('components.app.adverseEvent.risk-analysis', [])
  .component('riskAnalysis', riskAnalysisComponent)
  .value('EventEmitter', payload => ({ $event: payload }))
  .name;



// WEBPACK FOOTER //
// ./components/app/adverse-event/risk-analysis/risk-analysis.module.js